import { render, staticRenderFns } from "./TheCard.vue?vue&type=template&id=2f45dffc&scoped=true&"
import script from "./TheCard.vue?vue&type=script&lang=js&"
export * from "./TheCard.vue?vue&type=script&lang=js&"
import style0 from "./TheCard.vue?vue&type=style&index=0&id=2f45dffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45dffc",
  null
  
)

export default component.exports